import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-language-control',
  templateUrl: './language-control.component.html',
  styleUrls: ['./language-control.component.scss']
})
export class LanguageControlComponent implements OnInit {

  public language;

  constructor(
    private TranslateService: TranslateService
  ) { }

  ngOnInit() {
  }

  changeLanguage(value) {
    this.TranslateService.use(value);
  }

}
